import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Skeleton, SwitchProps } from "@mui/material";
import styled from "styled-components";
import { useEffect, useRef, useState, useCallback, useMemo } from "react";
import { useSettingContext } from "context/SettingContext";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import { getIcon } from "utils/iconsConfig";
import ClientModal from "components/ui/clientModal/clientModal";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "lib/api-client";
import { useGlobalContext } from "context/GlobalContext";
import { useClientCompanies, useToggleUpdatePurchaseAccess } from "./Api/myBinnysAccessApi";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificSubMenu, isAllowed } from "utils/checkUserRigths";
import { IOSSwitch } from "./IOSSwitch";
import { ReactComponent as UserIcon } from "assets/icons/CatalogueCard/user.svg";
import { ReactComponent as ReportIcon } from "assets/icons/Blue_ClientReport.svg";

const StyledTableContainer = styled(TableContainer)(({ }) => ({
  backgroundColor: "transparent",
  maxHeight: "90vh",
  // height: "70vh",
  overflowX: "auto",
  position: "relative",
  border: "1px solid #fff",
  scrollbarWidth: "none", // Firefox
  background: "#000",
  "&::-webkit-scrollbar": {
    height: "6px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888",
    borderRadius: "3px",
  },

  "@media (max-width: 768px)": {
    maxWidth: "100%",
    overflowX: "scroll",
    // border: "1px solid red",
  },

  "@media (min-width: 1200px)": {
    maxHeight: "66vh",
    // border: "1px solid blue",
  },

  "@media (min-width: 1400px)": {
    maxHeight: "63vh",
    // border: "1px solid yellow",
  },

  "@media (min-width: 1500px)": {
    maxHeight: "69vh",
    // border: "1px solid pink",
  },

  "@media (max-width: 1199px)": {
    maxHeight: "65vh",
    // border: "1px solid green",
  },
}));

const StyledTable = styled(Table)(({ }) => ({
  "& thead": {
    backgroundColor: "#444444",
    position: "sticky",
    top: 0,
    zIndex: 1,
    "& th": {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "22px",
      color: "#FFFFFF",
      textAlign: "center",
      fontFamily: "Poppins",
      padding: "10px",
      borderBottom: "1px solid #fff",
    },
  },
  "& tbody": {
    "& td": {
      fontSize: "18px",
      fontWeight: 400,
      lineHeight: "22px",
      color: "#FFFFFF",
      textAlign: "center",
      fontFamily: "Poppins",
      borderBottom: "1px solid #fff",
      padding: "10px 15px",
      border: "1px solid #fff",
    },
  },
  "& th": {
    // backgroundColor: "#444444",
    height: "50px",
    // position: "sticky",
    // top: 0,
    // zIndex: 1,
  },
}));

const StyledTableHeaderCell = styled(TableCell)`
  padding: 15px;
  font-size: 14px !important;
  font-weight: 400 !important;
  background-color: #444444;
  color: white;
  text-align: center !important;
  position: sticky;
  top: 0;
  z-index: 10;
  border: none !important;

  &.narrow {
    width: 10%;
  }

  &.default {
    width: 18%;
  }
`;

const StyledTableRow = styled(TableRow)`
  border-bottom: 1px solid #fff;
  & td {
    padding: 5px;
  }
`;

const StyledTableBodyCell = styled(TableCell)`
  padding: 10px;
  text-align: center;

   &.narrow {
    width: 10%; 

  &.default {
    width: 18%;
  }
`;

function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}

const MyBinnysAccess = () => {
  const { setCreateBtn, setCreateBtnName, addClient, setAddClient, search, setSearch, setSearchBar } = useSettingContext();
  const { setSearchPlaceHolder, setTotals, sortOptions, setSortOptions, sortValue, setSortValue } = useGlobalContext();
  const [dustbinModalOpen, setDustbinModalOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [isScrollLoading, setIsScrollLoading] = useState(false);
  const permissions = usePermissions();

  // Permission checks using the new structure
  const addClientPermission = isAllowed(findSpecificSubMenu(findSpecificMenu("My Binny's", permissions), "Client Management"), "add");
  const deleteClientPermission = isAllowed(findSpecificSubMenu(findSpecificMenu("My Binny's", permissions), "Client Management"), "delete");
  const hasViewAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("My Binny's", permissions), "Client Management"), "view");
  const hasUserAddAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("My Binny's", permissions), "User Management"), "add");
  const hasPurchaseAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("My Binny's", permissions), "Client Management"), "purchase_control");
  const hasReportViewAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("My Binny's", permissions), "Report Management"), "view");
  // const hasDownloadAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("My Binny's", permissions), "Client Management"), "download");
  const hasUserDeleteAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("My Binny's", permissions), "User Management"), "delete");
  const hasUserControlAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("My Binny's", permissions), "User Management"), "user_control");
  const UserIconAccess = hasUserAddAccess || hasUserDeleteAccess || hasUserControlAccess
  const navigate = useNavigate();
  const location = useLocation();
  const tableRef = useRef(null);
  const [downloadStates, setDownloadStates] = useState({});

  const handleDownloadToggle = (clientId, checked) => {
    setDownloadStates((prev) => ({
      ...prev,
      [clientId]: checked,
    }));
    handleTogglePurchasesPage(
      { clientId, action: "download" },
      {
        onError: () => {
          setDownloadStates((prev) => ({
            ...prev,
            [clientId]: !checked,
          }));
        },
      }
    );
  };

  const selectedOption = sortOptions.find((option) => option.id == sortValue);
  const hasDeleteAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("My Binny's", permissions), "Client Management"), "delete");
  const selectedSortBY = selectedOption?.sortBy;
  const selectedSortOrder = selectedOption?.order;

  useEffect(() => {
    setSortOptions([
      { id: 1, name: "Client Name (A to Z)", sortBy: "clientName", order: "asc" },
      { id: 2, name: "Client Name (Z to A)", sortBy: "clientName", order: "desc" },
      { id: 3, name: "Client Code (Low to High)", sortBy: "clientCode", order: "asc" },
      { id: 4, name: "Client Code (High to Low)", sortBy: "clientCode", order: "desc" },
      { id: 5, name: "Access Date (Oldest to Newest)", sortBy: "accessDate", order: "asc" },
      { id: 6, name: "Access Date (Newest to Oldest)", sortBy: "accessDate", order: "desc" },
      { id: 7, name: "No. of User (Low to High)", sortBy: "noOfUsers", order: "asc" },
      { id: 8, name: "No. of User (High to Low)", sortBy: "noOfUsers", order: "desc" },
    ]);
    setSearchBar(true);
    setSearchPlaceHolder("Search By Client Name ,Client Code ,Username , Mobile");

    return () => {
      setSearchBar(false);
      setSortOptions([]);
      setSortValue(null);
      setSearch("");
      setSearchPlaceHolder("");
    };
  }, []);

  //------------------------------------------------------------  CLIENT TABLE DATA API ------------------------------------------------------------------\\

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isError, refetch } = useClientCompanies(search, { sortBy: selectedSortBY, order: selectedSortOrder });
  const { mutate: handleTogglePurchasesPage, isLoading: loader } = useToggleUpdatePurchaseAccess();

  useEffect(() => {
    const element = tableRef.current;

    if (!element || !hasNextPage || isFetchingNextPage) return;

    const { scrollHeight, clientHeight } = element;

    if (scrollHeight <= clientHeight) {
      fetchNextPage();
    }
  }, [data, hasNextPage, isFetchingNextPage, fetchNextPage]);

  // Debounced scroll handler
  const handleScroll = useCallback(() => {
    const element = tableRef.current;
    if (!element || isFetchingNextPage || !hasNextPage) return;

    const { scrollTop, scrollHeight, clientHeight } = element;
    const reachedBottom = scrollTop + clientHeight >= scrollHeight - 10;

    if (reachedBottom) {
      setIsScrollLoading(true);
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);

  const debouncedHandleScroll = useMemo(() => debounce(handleScroll, 300), [handleScroll]);

  useEffect(() => {
    if (!isFetchingNextPage) {
      setIsScrollLoading(false);
    }
  }, [isFetchingNextPage]);

  useEffect(() => {
    const element = tableRef.current;

    if (element) {
      element.addEventListener("scroll", debouncedHandleScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener("scroll", debouncedHandleScroll);
      }
    };
  }, [debouncedHandleScroll]);

  useEffect(() => {
    setCreateBtn(addClientPermission);
    setCreateBtnName("Add Client +");
    return () => {
      setCreateBtn(false);
      setCreateBtnName("");
    };
  }, [addClientPermission]);

  useEffect(() => {
    if (data) {
      const allClients = data.pages.flatMap((page) => page.clients);
      const totalClients = data?.pages[0]?.totalClients;
      const totalUsers = data?.pages[0]?.totalUsers;

      setTotals({ totalClients, totalUsers });
    }
  }, [data]);

  const discardChanges = () => {
    setDustbinModalOpen(false);
  };

  const handleDelete = (rowData) => {
    setSelectedClient(rowData);
    setDustbinModalOpen(true);
  };

  //------------------------------------------------------------  DELETE ROW API ------------------------------------------------------------------\\

  const confirmDelete = async () => {
    if (!selectedClient) return;

    try {
      await apiClient.patch(`/api/v9/myBinnys/visionClientcompany?id=${selectedClient._id}`);
      refetch();
      setDustbinModalOpen(false);
    } catch (error) {
      console.error("Error deleting client:", error);
    }
  };

  const handleNavigate = (clientName, clientId, type) => {
    const modifyClientName = type === "report" ? `${clientName} Report` : clientName;
    const newState = {
      ...location.state,
      name: [location?.state?.name?.[0], modifyClientName],
      clientName,
    };
    const basePath = "/Setting/my-binnys-access";
    const fullPath = type === "report" ? `${basePath}/report/${clientId}` : `${basePath}/${clientId}`;
    navigate(fullPath, { state: newState });
  };

  const btnInfo = [
    {
      btnName: "Delete",
      bgColor: "#E77B7B",
      click: () => {
        confirmDelete();
      },
    },
    {
      btnName: "No",
      bgColor: "#50c878",
      click: () => {
        discardChanges();
      },
    },
  ];

  const TableSkeleton = ({ columns = 7, rows = 10 }) => (
    <>
      {Array.from(new Array(rows)).map((_, rowIndex) => (
        <StyledTableRow key={`skeleton-${rowIndex}`}>
          {Array.from(new Array(columns)).map((_, cellIndex) => (
            <StyledTableBodyCell key={`skeleton-cell-${cellIndex}`}>
              <Skeleton variant="text" sx={{ fontSize: "1rem" }} animation="wave" width={"100%"} height={"90%"} />
            </StyledTableBodyCell>
          ))}
        </StyledTableRow>
      ))}
    </>
  );

  return (
    <>
      {hasViewAccess && (
        <div style={{ marginTop: "15px", marginLeft: "6px", marginRight: "11.5px", backgroundColor: "#000", padding: "10px" }}>
          <StyledTableContainer ref={tableRef}>
            <StyledTable>
              <TableHead>
                <TableRow>
                  <StyledTableHeaderCell className="default">Client Name</StyledTableHeaderCell>
                  <StyledTableHeaderCell className="default">Client Code</StyledTableHeaderCell>
                  <StyledTableHeaderCell className="default">Created Date</StyledTableHeaderCell>
                  <StyledTableHeaderCell className="default">Created by</StyledTableHeaderCell>
                  <StyledTableHeaderCell className="narrow">No. of User</StyledTableHeaderCell>
                  <StyledTableHeaderCell className="narrow">Permissions</StyledTableHeaderCell>
                  <StyledTableHeaderCell className="default">Actions</StyledTableHeaderCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableSkeleton />
                ) : (
                  data?.pages
                    ?.flatMap((page) => page.clients)
                    ?.map((client, i) => (
                      <StyledTableRow key={client._id}>
                        <StyledTableBodyCell className="default">{client.clientName}</StyledTableBodyCell>
                        <StyledTableBodyCell className="default">#{client.clientCode}</StyledTableBodyCell>
                        <StyledTableBodyCell className="default">
                          {new Date(client.asseccDate).toLocaleDateString("en-GB", {
                            day: "numeric",
                            month: "short",
                            year: "numeric",
                          })}
                        </StyledTableBodyCell>
                        <StyledTableBodyCell className="default">{client.asseccBy}</StyledTableBodyCell>
                        <StyledTableBodyCell className="narrow">{client.noOfClientUsers}</StyledTableBodyCell>
                        <StyledTableBodyCell className="default">
                          <div style={{ display: "flex", gap: "10px" }}>
                            {hasPurchaseAccess && (
                              <IOSSwitch
                                disabled={loader}
                                label="Purchases"
                                checked={client?.isShowPurchasesPage || false}
                                onChange={(e) => {
                                  client.isShowPurchasesPage = e.target.checked;
                                  handleTogglePurchasesPage(client);
                                }}
                              />
                            )}

                            <IOSSwitch disabled={loader} label="Download" checked={
                              downloadStates[client._id] !== undefined
                                ? downloadStates[client._id]
                                : client?.hasDownloadAccess || false
                            }
                              onChange={(e) => handleDownloadToggle(client._id, e.target.checked)} />
                          </div>
                        </StyledTableBodyCell>
                        <StyledTableBodyCell className="default">
                          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", margin: "0px 15px" }}>
                            {UserIconAccess && (
                              <span style={{ cursor: "pointer", marginTop: "5px" }} onClick={() => handleNavigate(client.clientName, client._id, "user")}>
                                {getIcon("UserBorderIcon")}
                              </span>
                            )}

                            {hasReportViewAccess && (
                              <span style={{ cursor: "pointer", marginTop: "5px" }} onClick={() => handleNavigate(client.clientName, client._id, "report")}>
                                {getIcon("ReportBorderIcon")}
                              </span>
                            )}

                            {hasDeleteAccess && (
                              <span style={{ cursor: "pointer", marginTop: "5px" }} onClick={() => handleDelete(client)}>
                                {getIcon("DustbinBorderIcon")}
                              </span>
                            )}
                          </div>
                        </StyledTableBodyCell>
                      </StyledTableRow>
                    ))
                )}
                {isScrollLoading && <TableSkeleton rows={6} columns={7} />}
              </TableBody>
            </StyledTable>
          </StyledTableContainer>
        </div>
      )}
      <RemoveModal open={dustbinModalOpen} setOpen={setDustbinModalOpen} btnInfo={btnInfo} heading={`Are you sure you want to delete ${selectedClient?.clientName}?`} oneLiner={true} />
      <ClientModal open={addClient} onClose={() => setAddClient(false)} type="addClient" onSuccess={refetch} />
    </>
  );
};

export default MyBinnysAccess;
